import {
  TOGGLE_DETAILS_LOADING_STATUS,
  TOGGLE_FAVORITE_STATUS,
  UPDATE_FOLDER_PREVIEW_DETAILS,
  UPDATE_PREVIEW_FOLDER_SHARE_STATUS,
} from 'constants/actions';

export const updateFolderPreviewDetails = details => {
  return { type: UPDATE_FOLDER_PREVIEW_DETAILS, ...details };
};

export const toggleFavoriteStatus = isFavorite => {
  return { type: TOGGLE_FAVORITE_STATUS, isFavorite };
};

export const updatePreviewShareStatus = isShared => {
  return { type: UPDATE_PREVIEW_FOLDER_SHARE_STATUS, isShared };
};

export const toggleDetailsLoadingStatus = isLoading => {
  return { type: TOGGLE_DETAILS_LOADING_STATUS, isLoading };
};
